
import React from 'react'
import classNames from 'classnames'

class Input extends React.Component {

  constructor(props) {
    super(props)

    //this.handleMouseOver = this.handleMouseOver.bind(this)
  }

  // handleMouseOver(event) {
  //   if (this.props.onMouseOver) {
  //     this.props.onMouseOver({
  //       element: this.props.element,
  //       parentElements: this.props.parentElements
  //     })
  //   }
  // }

  render() {
    const {input} = this.props

    let placeholder = (input.placeholder !== undefined ? input.placeholder : '')

    return (
      <input
        className={classNames('filter-input', 'filter-input-' + input.valueFor )}
        placeholder={placeholder}
      />
    )
  }
}

export default Input
